module.exports = __webpack_public_path__ + "img/pic_location_Lienchiang.7baa5b2b.png";